module.exports = __webpack_public_path__ + "img/maham-pfp.fad309ec.png";